import React from "react";
import { TextImageWidget } from "@carfax/web-ui/components/TextImageWidget";
import { ModuleTextWithImage } from "@carfax/contentful/PageModularModule";
import RichTextWrapper from "./components/RichTextWrapper";
import SampleReport from "components/SampleReport";
import { ButtonVariants } from "@carfax/web-ui/shared/Button";

interface Props {
  module: ModuleTextWithImage;
  indexPosition: number;
}

const TextImage: React.FC<Props> = ({ module, indexPosition }) => {
  return (
    <TextImageWidget
      fetchPriorityHigh={indexPosition < 1}
      videoUrl={module.videoUrl}
      videoTitle={module.videoTitle}
      contentfulVideo={module.contentfulVideo}
      image={module.image}
      ctaLabel={module.ctaLabel}
      ctaLink={module.ctaLink}
      inverted={module.inverted}
      isAnimation={module.isAnimation}
      optionalTitle={module.optionalTitle}
      mobileImage={module.mobileImage}
      isLoop={module.isLoop}
    >
      <RichTextWrapper content={module.text} textAlign={module.textAlign} />
      {!!module.sampleReportButtonText && (
        <SampleReport
          optionalDesktopReport={module.optionalDesktopReport}
          optionalMobileReport={module.optionalMobileReport}
          withButton={true}
          buttonText={module.sampleReportButtonText}
          buttonVariant={ButtonVariants.Outlined}
        />
      )}
    </TextImageWidget>
  );
};

export default TextImage;
